module.exports = __webpack_public_path__ + "img/sunrise.a038f3a7.svg";